export function getDelimiters(_ref) {
  var input = _ref.input,
    delimiter = _ref.delimiter,
    textBeginning = _ref.textBeginning,
    textEnd = _ref.textEnd;
  var inputSplittedByLines = input.split("\n");
  inputSplittedByLines = inputSplittedByLines.filter(function (inputLine) {
    return inputLine.length > 0;
  });
  inputSplittedByLines = inputSplittedByLines.map(function (inputLine) {
    if (textEnd) {
      inputLine = textEnd + inputLine;
    }
    if (textBeginning) {
      inputLine = inputLine + textBeginning;
    }
    return inputLine;
  });
  return inputSplittedByLines.join("".concat(delimiter, "\n"));
}